"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

var _PhoneFill = _interopRequireDefault(require("@rsuite/icon-font/lib/device/PhoneFill"));

// Generated by script, don't edit it please.
var PhoneFill = (0, _createSvgIcon["default"])({
  as: _PhoneFill["default"],
  ariaLabel: 'phone fill',
  category: 'device',
  displayName: 'PhoneFill'
});
var _default = PhoneFill;
exports["default"] = _default;
module.exports = exports.default;